<template>
  <div class="h-100">
    <vue-headful title="مُرَيجَع | قاموس متواردات لفظية"/>
    <h1>
      <img src="logo-with-slogan-red-300px.png" class="logo">
    </h1>
    <p>
      مريجع قاموس للمتوارات اللفظية العربية<br/>
      يصف اللغة كما هي مستخدمة على أرض الواقع،<br/>
      بالاعتماد على تكنيات الذكاء الاصطناعي.
    </p>
    <p>
      لما لا تبدأ/ين بالبحث عن<br/>
      <router-link  tag="button" :to="'search/' + searchSuggestion" class="search-suggestion">
        {{searchSuggestion}}
      </router-link>
    </p>
    <p class="small">
        ما زال مريجع في مرحلة المسودة<br/>
         وندعوك إلى إبداء ملاحظاتك من خلال
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSdVUL8VPQhzd_v0CrgyJ03wkrQTho1TbctwJqLWU6vtc4PD7Q/viewform?hl=ar"
          target="_blank"
        >استمارة التقييم</a>.
    </p>
  </div>
</template>

<script>
import vueHeadful from 'vue-headful'
import { api } from '../mixins/api.js'

export default {
  name: 'Home',
  components: { vueHeadful },
  mixins: [api],
  data: function () { return { searchSuggestion: null } },
  created: function () {
    var t = this
    this.getRecentlyAddedGoodCols(20).then(function (r) {
      var change = r.data[Math.floor(Math.random() * r.data.length)]
      t.searchSuggestion = t.lempos2lemma(change.lempos)
    })
  }

}
</script>

<style scoped>
.logo {
  max-width: 500px;
  width: 80%
}

h1, p {
  text-align: center;
  margin: 0% 15%
}
h1 {
  padding: 50px 0
}
p {
  color: darkgray;
  font-size: 22px;
  margin-bottom: 20px;
}
p.small {
  font-size: 16px;
}

.warning {
  margin-top: 40px;
  color: #FF5555;
  font-size: 15px;
}

.warning a {
  color: #FF5555;
  text-decoration: underline
}

.search-suggestion {
  border: 2px solid #FF5555;
  padding: 0px 5px 5px 5px
}
</style>
